




























import { Component, Vue } from "vue-property-decorator";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import NoData from "@/basics/boxes/NoData.vue";
import { ROOM_ONE, RoomData, RoomVariables } from "@/graphql/query/room/one";

interface Group {
  id: string;
  name: string;
}

interface ApolloData {
  groups: Group[];
}

@Component({
  components: {
    SimpleTable,
    NoData
  },
  apollo: {
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        return {
          roomId: this.$apollo.vm.$route.params.roomId
        };
      }
    }
  }
})
export default class RoomDetails extends Vue {
  room: RoomData | null = null;

  get hasDevices(): boolean {
    return !!(
      this.room &&
      (this.room.mainLock || this.room.subLock || this.room.hub)
    );
  }
}
